import { useState } from 'react';
import { ASC, DESC } from '../constants';
import { SORTING_CREATED_AT } from '../../modules/pricingPlans/constants';

export const useListFilters = () => {
  const [sorting, setSorting] = useState(SORTING_CREATED_AT);
  const [order, setOrder] = useState(DESC);

  const sortBy = (field: string = ASC) => {
    if (sorting === field && order === ASC) {
      orderBy(DESC);
    } else if (sorting === field) {
      setSorting(SORTING_CREATED_AT);
      orderBy(ASC);
    } else {
      setSorting(field);
      orderBy(ASC);
    }
  };

  const orderBy = (direction: string) => {
    setOrder(direction);
  };

  return { sorting, sortBy, order, orderBy };
};
